import { render, staticRenderFns } from "./CreateProductDynamicForm.vue?vue&type=template&id=c8e3f98e&scoped=true&"
import script from "./CreateProductDynamicForm.vue?vue&type=script&lang=js&"
export * from "./CreateProductDynamicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e3f98e",
  null
  
)

export default component.exports